"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'whatsapp.settingsList.title': 'Agenci Komunikacji',
    'whatsapp.settingsList.add': 'Dodaj numer telefonu',
    'whatsapp.settingsList.empty': 'Brak skonfigurowanych numerów telefonów. Dodaj pierwszy, aby zacząć.',
    'whatsapp.settingsList.language': 'Język',
    'whatsapp.settingsList.avatar': 'Avatar',
    'whatsapp.settingsList.actions': 'Akcje',
    'whatsapp.settingsList.loadFailed': 'Nie udało się załadować konfiguracji WhatsApp.',
    'whatsapp.settingsList.deleteConfirm': 'Czy na pewno chcesz usunąć tę konfigurację WhatsApp?',
    'whatsapp.settingsList.deleted': 'Konfiguracja WhatsApp została usunięta.',
    'whatsapp.settingsList.deleteFailed': 'Nie udało się usunąć konfiguracji WhatsApp.',
};
